import AuthStore from 'stores/authStore'
import CollectionStore from 'stores/collectionStore'
import OrganizationStore from 'stores/organizationStore'
import ProcessStore from 'stores/processStore'
import UserStore from 'stores/userStore'
import CommonLibraryStore from './commonLibraryStore'
import EcnSuggestionStore from './ecnSuggestionStore'
import FavoriteStore from './favoriteStore'
import GeneralStore from './generalStore'
import GroupStore from './groupStore'
import IconBuilderStore from './iconBuilderStore'
import MessageStore from './messageStore'
import NotificationStore from './notificationStore'
import ReportStore from './reportStore'
import SearchStore from './searchStore'
import SpinnerStore from './spinnerStore'
import StepStore from './stepStore'
import TagStore from './tagStore'
import ThemeStore from './themeStore'
import SsoConfigStore from './ssoConfig.store'
import PlanStore from './planStore'
import ScheduleStore from './scheduleStore'
import UserWorkplanStore from './userWorkplanStore'
import TrainingPlanStore from './trainingPlanStore'
import TrainingPlanDetailStore from './trainingPlanDetailStore'
import TrainingAssignmentStore from './trainingAssignmentStore'
import MetricStore from './metricStore'
import PlayerAssignmentStore from './playerAssignmentStore'
import PlayerProfileStore from './playerProfileStore'
import ProfileStore from './profileStore'
import TeamsStore from './teamsStore'
import PracticeLibraryStore from './practiceLibraryStore'
import TrainingLibraryStore from './trainingLibraryStore'

export class RootStore {
  spinnerStore: SpinnerStore
  commonLibraryStore: CommonLibraryStore
  authStore: AuthStore
  organizationStore: OrganizationStore
  userStore: UserStore
  processStore: ProcessStore
  favoriteStore: FavoriteStore
  searchStore: SearchStore
  collectionStore: CollectionStore
  stepStore: StepStore
  notificationStore: NotificationStore
  groupStore: GroupStore
  messageStore: MessageStore
  tagStore: TagStore
  iconBuilderStore: IconBuilderStore
  ecnSuggestionStore: EcnSuggestionStore
  themeStore: ThemeStore
  reportStore: ReportStore
  generalStore: GeneralStore
  ssoConfigStore: SsoConfigStore
  planStore: PlanStore
  scheduleStore: ScheduleStore
  userWorkplanStore: UserWorkplanStore
  trainingPlanStore: TrainingPlanStore
  trainingPlanDetailStore: TrainingPlanDetailStore
  trainingAssignmentStore: TrainingAssignmentStore
  metricStore: MetricStore
  playerAssignmentStore: PlayerAssignmentStore
  playerProfileStore: PlayerProfileStore
  profileStore: ProfileStore
  teamsStore: TeamsStore
  practiceLibraryStore: PracticeLibraryStore
  trainingLibraryStore: TrainingLibraryStore

  constructor() {
    this.spinnerStore = new SpinnerStore(this)
    this.commonLibraryStore = new CommonLibraryStore(this)
    this.authStore = new AuthStore(this)
    this.organizationStore = new OrganizationStore(this)
    this.userStore = new UserStore(this)
    this.processStore = new ProcessStore(this)
    this.favoriteStore = new FavoriteStore(this)
    this.searchStore = new SearchStore(this)
    this.collectionStore = new CollectionStore(this)
    this.stepStore = new StepStore(this)
    this.notificationStore = new NotificationStore(this)
    this.groupStore = new GroupStore(this)
    this.messageStore = new MessageStore(this)
    this.tagStore = new TagStore(this)
    this.iconBuilderStore = new IconBuilderStore(this)
    this.ecnSuggestionStore = new EcnSuggestionStore(this)
    this.themeStore = new ThemeStore(this)
    this.reportStore = new ReportStore(this)
    this.generalStore = new GeneralStore(this)
    this.ssoConfigStore = new SsoConfigStore(this)
    this.planStore = new PlanStore(this)
    this.scheduleStore = new ScheduleStore(this)
    this.userWorkplanStore = new UserWorkplanStore(this)
    this.trainingPlanStore = new TrainingPlanStore(this)
    this.trainingPlanDetailStore = new TrainingPlanDetailStore(this)
    this.trainingAssignmentStore = new TrainingAssignmentStore(this)
    this.metricStore = new MetricStore(this)
    this.playerAssignmentStore = new PlayerAssignmentStore(this)
    this.playerProfileStore = new PlayerProfileStore(this)
    this.profileStore = new ProfileStore(this)
    this.teamsStore = new TeamsStore(this)
    this.practiceLibraryStore = new PracticeLibraryStore(this)
    this.trainingLibraryStore = new TrainingLibraryStore(this)
  }
}

export const rootStore = new RootStore()
